/**
 * Copyright (c) Stanislav Shishankin
 *
 * This source code is licensed under the MIT license.
 */

let {zzArray, zzReactive} = require('../index');
let {ViewComponent} = require('./View');
let {LinkToView, LinkToViewElement} = require('./Link');

class ArrayDOM{
    appendDOM(data, viewBefore){
        let view;
        if (data instanceof ViewComponent){
            view = data;
        }else if (typeof this.fnname === 'function'){
            view = this.fnname.call(data, data);
        }else if (data && data[this.fnname]){
            view = data[this.fnname].call(data);
        }
        
        if (view instanceof ViewComponent){
            view.appendDOM(this.DOM, viewBefore || this.before);
        }
        return view;
    }
    
    replace(){
        let newValues = this.array.value;
        let newViewComponent = new Map;
        let maxIndex = this.views.length;
        let viewBefore = null;
        
        for (let i = newValues.length - 1; i >= 0; i--){
            let data = newValues[i];
            
            if (!data){
                continue;
            }
            
            let view = null;
            let dataView = this.views.get(data);
            if (dataView){
                view = dataView.view;
                
                if (dataView.index < maxIndex){
                    maxIndex = dataView.index;
                }else{
                    view.appendDOM(this.DOM, viewBefore);
                }

                this.views.delete(data);
            }else{
                view = this.appendDOM(data, viewBefore);
            }
            
            if (view instanceof ViewComponent){
                viewBefore = view;

                newViewComponent.set(data, {
                    view: view,
                    index: i
                });
            }
        };
        
        this.views.forEach((d) => d.view.removeDOM());
        this.views.clear();
        
        this.views = newViewComponent;
    }
    
    remove(event){
        for (let data of event.removed){
            let d = this.views.get(data);
            if (d){
                d.view.removeDOM();
                this.views.delete(data);
            }else{
                console.error("Unsynced data found", data);
                return;
            }
        }
    }
    
    add(event){
        let idx = event.index;
        let viewBefore = null;
        if (idx < this.views.length){
            for (let d of this.views){
                if (d.index === idx){
                    viewBefore = d.view;
                }

                if (d.index >= idx){
                    d.index += event.added.length;
                }
            }
        }

        for (let i in event.added){
            let data = event.added[i];
            let view = this.appendDOM(data, viewBefore);

            if (view instanceof ViewComponent){
                this.views.set(data, {
                    view: view,
                    index: idx + i
                });
            }
        }
    }
    
    removeDOM(){
        if (this.array instanceof zzArray)
        this.array.off(this);

        this.views.forEach(function(d){
            d.view.removeDOM();
        });
        
        this.array = null;
    }
    
    connectDOM(array){
        if (array instanceof zzArray){
            this.array = array;
            this.array.on('add', this.add, this);
            this.array.on('remove', this.remove, this);
            this.array.on('replace', this.replace, this);
            this.replace( array.value );
        }else{
            console.error('Error: ', array, ' is not zzArray');
        }
    }
    
    constructor(el, before, array, fnname, view){
        this.views = new Map;
        this.DOM = el;
        this.before = before;
        this.fnname = fnname;
        this.view = view;
        
        this.connectDOM(array);
    }
}

class ArrayLink extends LinkToViewElement{
    addEventsToEL(el){
        this.added.push(
            new ArrayDOM(el, null, this.collection, this.fnname, this.view)
        );
    }

    clearEvents(DOMel){
        for (let i in this.added){
            this.added[i].removeDOM();
        }
        
        this.added = [];
    }

    constructor(selector, collection, fnname){
        super(selector);
        
        if (!(collection instanceof zzArray)){
            console.error('Error: linked array is not zzArray');
        }
        
        this.collection = collection;
        this.fnname = fnname;
        this.added = [];
    }
};

class ArrayInsertBeforeLink extends LinkToView{
    addEvents(){
        this.added.push(
            new ArrayDOM(this.before.parentNode, this.before, this.collection, this.fnname, this.view)
        );
    }

    clearEvents(DOMel){
        for (let i in this.added){
            this.added[i].removeDOM();
        }
        
        this.added = [];
    }

    constructor(before, collection, fnname){
        super();
        
        if (!(collection instanceof zzArray)){
            console.error('Error: linked array is not zzArray');
        }
        
        this.collection = collection;
        this.fnname = fnname;
        this.before = before;
        this.added = [];
    }
};

class AnimationArrayDOM extends ArrayDOM{
    replace(newValues){        
        let newViewComponent = [];
        this.views.forEach((d, i) => d.data.__zzIndeX = i);
                
        if (newValues.length > 0){
            for (let data of newValues){
                if (!data){
                    continue;
                }
                
                let view = null;
                if ('__zzIndeX' in data){
                    view = this.views[data.__zzIndeX].view;
                    delete data.__zzIndeX;
                }else{
                    if (data instanceof ViewComponent){
                        view = data;
                    }else if (data && data[this.fnname]){
                        view = data[this.fnname].call(data);
                    }
                    
                    if (view instanceof ViewComponent){
                        //only if new
                        view.appendDOM(this.DOM);
                    }
                }
                
                if (view instanceof ViewComponent){
                    newViewComponent.push({
                        data: data,
                        view: view
                    });
                }
            };
        }
        
        let removeSort = this.views;//.slice(0);
        for (let f of removeSort){
            if ('__zzIndeX' in f.data){
                delete f.data.__zzIndeX;
                f.view.removeDOM();
            }
        }            
        
        this.views = newViewComponent;
    }
};

class ArrayNoSortLink extends LinkToViewElement{
    addEventsToEL(el){
        this.added.push(
            new AnimationArrayDOM(el, null, this.collection, this.fnname, this.view)
        );
    }

    clearEvents(DOMel){
        for (let i in this.added){
            this.added[i].removeDOM();
        }
        
        this.added = [];
    }

    constructor(selector, collection, fnname){
        super(selector);
        
        if (!(collection instanceof zzArray)){
            console.error('Error: linked array is not zzArray');
        }
        
        this.collection = collection;
        this.fnname = fnname;
        this.added = [];
    }
};

class Initialize extends LinkToView{
    addEvents(){
        if (this.initFn){
            this.initFn( this.view );
        }
    }

    async clearEvents(){
        if (this.destroyFn){
            await this.destroyFn(this.view);
        }
    }

    constructor(initFn, destroyFn){
        super();
        
        this.initFn = initFn;
        this.destroyFn = destroyFn;
    }
}

class ViewLink extends LinkToViewElement{
    async removeDOM(){
        await Promise.all( this.added.map(d => d.removeDOM()) );
        
        this.added = [];
    }
    
    addDOM(value){
        if (!value) return;

        for (let el of this.elements){
            let data = value;

            if (!(data instanceof ViewComponent)){
                if (data[this.fn]){
                    data = data[this.fn].call(data, data);
                }else if('function' === typeof this.fn){
                    data = this.fn.call(data, data);
                }
            }

            if (!data) continue;

            if (data instanceof ViewComponent){
                data.appendDOM(el);

                this.added.push( data );
            }
        }
    }
    
    addEvents(){
        if (this.value instanceof zzReactive){
            let inside = false;
            this.value.change(async function(){
                if (!inside){
                    inside = true;
                    await this.removeDOM();

                    this.addDOM(this.value.value);
                    inside = false;
                }
            }, this);

            this.addDOM(this.value.value);
        }else{
            this.addDOM(this.value);
        }
    }

    clearEvents(){
        if (this.value instanceof zzReactive){
            this.value.off(this);
        }

        this.removeDOM();
    }

    constructor(selector, value, fn){
        super(selector);
        
        this.value = value;
        this.fn = fn;
        this.added = [];
    }
}

class ViewInsertBeforeLink extends LinkToView{
    async removeDOM(){
        await Promise.all( this.added.map(d => d.removeDOM()) );
        
        this.added = [];
    }
    
    addDOM(value){
        if (!value) return;

        let data = value;

        if (!(data instanceof ViewComponent)){
            if (data[this.fn]){
                data = data[this.fn].call(data, data);
            }else if('function' === typeof this.fn){
                data = this.fn.call(data, data);
            }
        }

        if (!data) return;

        if (data instanceof ViewComponent){
            data.appendDOM(this.before.parentNode, this.before);

            this.added.push( data );
        }
    }
    
    addEvents(){
        if (this.value instanceof zzReactive){
            let inside = false;
            this.value.change(async function(){
                if (!inside){
                    inside = true;
                    await this.removeDOM();

                    this.addDOM(this.value.value);
                    inside = false;
                }
            }, this);

            this.addDOM(this.value.value);
        }else{
            this.addDOM(this.value);
        }
    }

    clearEvents(){
        if (this.value instanceof zzReactive){
            this.value.off(this);
        }

        this.removeDOM();
    }

    constructor(before, value, fn){
        super();
        
        this.value = value;
        this.fn = fn;
        this.added = [];
        this.before = before;
    }
};

class EventLink extends LinkToView{
    addEvents(view){
        if (this.self instanceof Array){
            for (let el of this.self){
                this.args[0] = el;
                let ev = view.ev.apply(view, this.args);

                if (this.isRun){
                    ev.run(this.isRun);
                }
            }
        }else if (this.args[0]){
            let ev = view.ev.apply(view, this.args);

            if (this.isRun){
                ev.run(this.isRun);
            }
        }
    }

    linkView(view){
        super.linkView(view);

        if (typeof this.args[0] === 'string'){
            this.self = view.findAll( this.args[0] );
        }
    }

    run(){
        this.isRun = Array.prototype.slice.call(arguments);

        return this;
    }

    constructor(){
        super();
        
        this.args = Array.prototype.slice.call(arguments);
        this.self = null;
        this.isRun = null;
    }
}

class LizziViewComponent extends ViewComponent{
    array(selector, collection, fnname, animation){
        if (animation === true){
            return this.link( new ArrayNoSortLink(selector, collection, fnname) );
        }else if (!animation){
            return this.link( new ArrayLink(selector, collection, fnname) );
        }
    }
    
    view(selector, component, fnname){
        return this.link( new ViewLink(selector, component, fnname) );
    }    
    
    init(initFn, destroyFn){
        return this.link( new Initialize(initFn, destroyFn) );
    }
    
    eventStart(self, eventName, listenerFn, options){
        return this.link( new EventLink(self, eventName, listenerFn, options).run([]) );
    }
    
    event(self, eventName, listenerFn, options){
        return this.link( new EventLink(self, eventName, listenerFn, options) );
    }
}

module.exports = {EventLink, ViewLink, ViewInsertBeforeLink, Initialize, ArrayNoSortLink, ArrayLink, ArrayInsertBeforeLink, LizziViewComponent};